import { createApp, defineAsyncComponent } from 'vue'
import { loadFonts } from './plugins/webfontloader'

import { createPinia, PiniaPlugin } from 'pinia'
import { useUserStore } from '@/stores/user'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import Vue from 'vue'

//라이브러리
import axios from 'axios';
import router from './router'
import vuetify from './plugins/vuetify'
import mitt from 'mitt'
import { emitter } from './emitter';

import momenttz from 'moment-timezone'

import Swal from 'sweetalert2'
import sweetAlertPlugin from './plugins/sweetalert2'
import Vue3Storage, { StorageType } from "vue3-storage";

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'


//공통 컴포넌트
import DialogScreenBGColor from '@/components/DialogScreenBGColor.vue'
import DialogScreenGRColor from '@/components/DialogScreenGRColor.vue'
import DialogColor from '@/components/DialogColor.vue'
import DialogBGColor from '@/components/DialogBGColor.vue'
import DialogFTColor from '@/components/DialogFTColor.vue'
import DialogFont from '@/components/DialogFont.vue'
import DialogGRColor from '@/components/DialogGRColor.vue'
import DialogMask from '@/components/DialogMask.vue'
import DialogSDColor from '@/components/DialogSDColor.vue'
import Dialog_Content from '@/components/Dialog_Content.vue'
import Dialog_MyContent from '@/components/Dialog_MyContent.vue'
import Dialog_Company from '@/components/Dialog_Company.vue'

import DialogMaskList from '@/components/DialogMaskList.vue'
import DialogColorList from '@/components/DialogColorList.vue'
import DialogFontList from '@/components/DialogFontList.vue'
import DialogFTColorList from '@/components/DialogFTColorList.vue'
import DialogBGColorList from '@/components/DialogBGColorList.vue'
import DialogGRColorList from '@/components/DialogGRColorList.vue'
import DialogSDColorList from '@/components/DialogSDColorList.vue'

import Com_Pagingbar from '@/components/Com_Pagingbar.vue'
import Com_Searchbar from '@/components/Com_Searchbar.vue'
import Com_Accnt from '@/components/Com_Accnt.vue'
import Com_Content from '@/components/Com_Content.vue'
import Com_Ani from '@/components/Com_Ani.vue'
import Com_MyAni from '@/components/Com_MyAni.vue'
import Com_Play from '@/components/Com_Play.vue'
import Com_Font from '@/components/Com_Font.vue'
import Com_Payment from '@/components/Com_Payment.vue'
import Com_Subscription from '@/components/Com_Subscription.vue'
import Com_Loading from '@/components/Com_Loading.vue'
import Com_EditSlider from '@/components/Com_EditSlider.vue'

import Com_EditSliderList from '@/components/Com_EditSliderList.vue'

import Com_PrivacyPolicy from '@/components/Com_PrivacyPolicy.vue'

import LayerComponent from '@/nextvue/preview/LayerComponent.vue'


//파이어베이스
import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database"

const firebaseConfig = {
  apiKey: "AIzaSyANxM9e4ZrHWa5jMLEvuaSBcyllne1pniA",
  authDomain: "necsolution-59f61.firebaseapp.com",
  databaseURL: "https://necsolution-59f61-default-rtdb.firebaseio.com/",
  projectId: "necsolution-59f61",
  storageBucket: "necsolution-59f61.appspot.com",
  messagingSenderId: "785162106319",
  appId: "1:785162106319:web:048b72ec35b41d78b54eba",
  measurementId: "G-DM2GXF8CF0"
};
const firebase  = initializeApp(firebaseConfig);
const auth      = getAuth(firebase);
const db        = getFirestore(firebase);
const rdb       = getDatabase(firebase);
const storage   = getStorage(firebase, "gs://necsolution-59f61.appspot.com");

//전역 이벤트
//const emitter = mitt();

loadFonts()

const app = createApp(App);
app.config.globalProperties.$firebase     = firebase;
app.config.globalProperties.$fireauth     = auth;
app.config.globalProperties.$firestore    = db;
app.config.globalProperties.$firedb       = rdb;
app.config.globalProperties.$firestorage  = storage;
app.config.globalProperties.$storagepath  = "https://storage.googleapis.com/necsolution-59f61.appspot.com/";
app.config.globalProperties.$http         = axios;

//포트원 설정
app.config.globalProperties.$STOREID         = "store-256760ee-b31a-4721-a1ff-d6a73a104790";
app.config.globalProperties.$CHANNELKEY_BILL = "channel-key-e11dfb2e-59b0-46a5-b353-810429c25ba0"; //정기결제
//app.config.globalProperties.$CHANNELKEY_BILL = "channel-key-dddca42b-85e9-4b2a-a8e7-cd220d9960b3"; //정기결제 테스트

//===== PWA 서비스 워커 등록 (A2HS 설치 + 캐시 무효화) =====
//새 배포 시 아래 버전과 public/service-worker.js의 CACHE_VERSION을 함께 올릴 것!
const EXPECTED_CACHE_VERSION = "v6";

//app.config.globalProperties.$api_home       = "http://192.168.0.39:8080";
app.config.globalProperties.$api_home     = "https://api.barosquare.com";

//동영상 변환 Cloud Function(Cloud Run) — ECS/CloudFront 우회 직접 호출 (60초 캡 회피)
app.config.globalProperties.$transcode_url  = "https://us-central1-necsolution-59f61.cloudfunctions.net/transcodeVideo";

app.config.globalProperties.$momenttz   = momenttz;
app.config.globalProperties.$alert      = Swal;
app.config.globalProperties.$emitter    = emitter;


//커스텀 컴포넌트
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogscbgcolor", DialogScreenBGColor);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogscgrcolor", DialogScreenGRColor);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogcolor", DialogColor);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogbgcolor", DialogBGColor);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogftcolor", DialogFTColor);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogfont", DialogFont);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialoggrcolor", DialogGRColor);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogmask", DialogMask);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogsdcolor", DialogSDColor);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogcontent", Dialog_Content);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogmycontent", Dialog_MyContent);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogcompany", Dialog_Company);

// eslint-disable-next-line vue/multi-word-component-names
app.component("searchbar", Com_Searchbar);
// eslint-disable-next-line vue/multi-word-component-names
app.component("pagingbar", Com_Pagingbar);
// eslint-disable-next-line vue/multi-word-component-names
app.component("comaccnt", Com_Accnt);
// eslint-disable-next-line vue/multi-word-component-names
app.component("comcontent", Com_Content);
// eslint-disable-next-line vue/multi-word-component-names
app.component("comani", Com_Ani);
// eslint-disable-next-line vue/multi-word-component-names
app.component("commyani", Com_MyAni);
// eslint-disable-next-line vue/multi-word-component-names
app.component("complay", Com_Play);
// eslint-disable-next-line vue/multi-word-component-names
app.component("comfont", Com_Font);
// eslint-disable-next-line vue/multi-word-component-names
app.component("compayment", Com_Payment);
// eslint-disable-next-line vue/multi-word-component-names
app.component("comsubscript", Com_Subscription);
// eslint-disable-next-line vue/multi-word-component-names
app.component("comloading", Com_Loading);
// eslint-disable-next-line vue/multi-word-component-names
app.component("comeditslider", Com_EditSlider);

// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogmasklist", DialogMaskList);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogcolorlist", DialogColorList);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogfontlist", DialogFontList);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogftcolorlist", DialogFTColorList);
// eslint-disable-next-line vue/multi-word-component-names
app.component("comeditsliderlist", Com_EditSliderList);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogbgcolorlist", DialogBGColorList);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialoggrcolorlist", DialogGRColorList);
// eslint-disable-next-line vue/multi-word-component-names
app.component("dialogsdcolorlist", DialogSDColorList);


// eslint-disable-next-line vue/multi-word-component-names
app.component("layercomponent", LayerComponent);

// eslint-disable-next-line vue/multi-word-component-names
app.component("comprivacypolicy", defineAsyncComponent(() => 
  import('@/components/Com_PrivacyPolicy.vue')
));
// eslint-disable-next-line vue/multi-word-component-names
app.component("comtermservice", defineAsyncComponent(() =>
  import('@/components/Com_TermService.vue')
));
// eslint-disable-next-line vue/multi-word-component-names
app.component("commkt", defineAsyncComponent(() =>
  import('@/components/Com_Mkt.vue')
));







const piana = createPinia();
piana.use(piniaPluginPersistedstate as unknown as PiniaPlugin)
app.use(vuetify);
app.use(router);
app.use(sweetAlertPlugin);
app.use(piana);
//pinia 전역 설정
const userStore = useUserStore();
app.config.globalProperties.$userStore = userStore;

app.use(VueViewer);
app.use(Vue3Storage, {namespace:"session_", storage:StorageType.Session})
//app.use(VueSessionStorage);
app.mount('#app');


if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('서비스 워커가 등록되었습니다:', registration.scope);

        // 새 버전 감지 시 자동 새로고침
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('새 버전 설치 완료, 페이지를 새로고침합니다.');
              setTimeout(() => { window.location.reload(); }, 1000);
            }
          });
        });

        // 즉시 업데이트 확인
        registration.update();
      })
      .catch(error => {
        console.error('서비스 워커 등록 실패:', error);
      });
  });

  // 서비스 워커로부터 캐시 업데이트 메시지 수신 → 버전 다르면 새로고침
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'CACHE_UPDATED') {
      const currentVersion = localStorage.getItem('sw_cache_version');
      if (currentVersion !== event.data.version) {
        localStorage.setItem('sw_cache_version', event.data.version);
        window.location.reload();
      }
    }
  });

  // 초기 버전 체크 (기존 버전 정보 없는 사용자 → 구버전 캐시 전체 삭제)
  const currentVersion = localStorage.getItem('sw_cache_version');
  if (!currentVersion) {
    if ('caches' in window) {
      caches.keys().then(names => {
        Promise.all(names.map(name => caches.delete(name))).then(() => {
          localStorage.setItem('sw_cache_version', EXPECTED_CACHE_VERSION);
        });
      });
    }
  }
}

//===== PWA 설치 프롬프트 전역 캡처 (in-app "설치하기" 버튼용) =====
//beforeinstallprompt는 로드 극초반 1회만 발생 → 늦게 마운트되는 컴포넌트가 놓치지 않도록 전역 보관.
(window as any).__bsInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();              // 브라우저 기본 미니바 방지 → 우리 버튼으로 유도
  (window as any).__bsInstallPrompt = e;
  emitter.emit('pwa-installable'); // 버튼 노출 신호
});
window.addEventListener('appinstalled', () => {
  (window as any).__bsInstallPrompt = null;
  emitter.emit('pwa-installed');   // 버튼 숨김 신호
});

